const HowItWork = () => {
  const steps = [
    {
      title: 'Product/Service Sales',
      description:
        'SALE: Consumers purchase or consume a product or service. KnowQuest: Businesses work with KnowQuest to drive consumers to the KnowQuest platform.',
    },
    {
      title: 'Credibility Check & Review',
      description:
        'Credibility Check: Consumers pass a unique credibility check to unlock the ability to review the product or service. Reviews: Consumers can now leave meaningful, representative reviews in about a minute.',
    },
    {
      title: 'Search and Subscribe',
      description:
        'Search: Users search through aggregated reviews to find exactly what they are looking for. Subscribe: Businesses subscribe to dashboards to make informed decisions.',
    },
  ];

  return (
    <div className="min-h-[calc(100vh-400px)] max-w-screen-xl mx-auto lg:mt-10 mt-6  mb-4 px-4">
      <h1 className="text-4xl font-bold text-secondary text-center mb-4">
        How It Works
      </h1>

      <p className="text-lg text-justify text-white mb-8 leading-relaxed mx-4">
        KnowQuest is built to be the next evolution in online feedback.
        <br />
        <span className="font-semibold text-justify">
          Easier to Implement & More Informative · Less Expensive & Easier to
          Use
        </span>
      </p>

      <div className="grid md:grid-cols-3 gap-8 mx-4">
        {steps.map((step, index) => (
          <div
            key={index}
            className="relative p-6 bg-white shadow-lg  rounded-3xl hover:shadow-2xl 
            transition-transform transform hover:-translate-y-2"
          >
            <div className="absolute top-0 left-0 bg-secondary text-white w-12 h-12 flex items-center justify-center rounded-br-xl text-xl font-bold">
              {index + 1}
            </div>
            <h2 className="text-2xl font-semibold text-secondary mb-4 mt-8">
              {step.title}
            </h2>
            <p className="text-gray-600 leading-relaxed">{step.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HowItWork;
